import React from 'react';
import ModernFAQ from '../../MicrospecDynamicUI/Pages/SectionsMapper/Content/ModernFAQ';
import { ModernFAQSpec } from '../../MicrospecDynamicUI/Pages/SectionsMapper/Content/ModernFAQ/types';

const spec: ModernFAQSpec = {
    id: 'faq',
    title: { localizationObject: { type: 'Literal', text: 'שאלות נפוצות' } },
    subtitle: {
        localizationObject: {
            type: 'Literal',
            text: 'כל מה שרצית לדעת על עץ, הזמנות ומשלוחים — במקום אחד',
        },
    },
    enableSearch: true,
    defaultExpanded: false,
    allowMultipleExpanded: true,

    categories: [
        { id: 'general',   name: { localizationObject: { type: 'Literal', text: 'כללי' } },              icon: '💡' },
        { id: 'wood',      name: { localizationObject: { type: 'Literal', text: 'סוגי עץ' } },            icon: '🪵' },
        { id: 'orders',    name: { localizationObject: { type: 'Literal', text: 'הזמנה ומשלוח' } },       icon: '🚚' },
        { id: 'treatment', name: { localizationObject: { type: 'Literal', text: 'טיפול ועיבוד' } },       icon: '🔨' },
        { id: 'pricing',   name: { localizationObject: { type: 'Literal', text: 'מחירים ותשלום' } },      icon: '💰' },
        { id: 'cert',      name: { localizationObject: { type: 'Literal', text: 'תקנים והסמכות' } },      icon: '📋' },
    ],

    faqs: [
        // ─── כללי ───────────────────────────────────────────────────────────
        {
            category: 'general',
            question: { localizationObject: { type: 'Literal', text: 'מי אנחנו?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'גולן סחר עץ היא חברה ישראלית המתמחה באספקת עצים ומוצרי עץ איכותיים לקבלנים, אדריכלים, נגרים ולקוחות פרטיים. אנו מחברים את הלקוח ישירות למקור — בלי מתווכים — ומבטיחים מחירים תחרותיים ואיכות גבוהה.',
                },
            },
        },
        {
            category: 'general',
            question: { localizationObject: { type: 'Literal', text: 'לאילו לקוחות אתם מתאימים?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'אנו משרתים מגוון רחב של לקוחות: קבלני בנייה, נגרים ויצרני רהיטים, אדריכלים ומעצבי פנים, חברות נוף וגינון, ולקוחות פרטיים המתכננים פרויקט DIY. בין אם מדובר בהזמנה קטנה של כמה לוחות ועד להזמנות תעשייתיות של קורות מבניות — אנחנו כאן.',
                },
            },
        },
        {
            category: 'general',
            question: { localizationObject: { type: 'Literal', text: 'כיצד ניתן ליצור קשר לקבלת ייעוץ?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'ניתן ליצור קשר דרך טופס "צור קשר" באתר, בטלפון, או בוואטסאפ. הצוות שלנו יחזור אליכם תוך יום עסקים ויסייע בבחירת הסוג, הכמות והגמר המתאים לפרויקט.',
                },
            },
        },

        // ─── סוגי עץ ────────────────────────────────────────────────────────
        {
            category: 'wood',
            question: { localizationObject: { type: 'Literal', text: 'אילו סוגי עץ אתם מספקים?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'המלאי שלנו כולל מעל 50 סוגי עץ: עצים קשים (אורן, ברוש, אלון, בוק, אגוז, מהגוני, טיק), עצים רכים (ארז, עץ אורן צפוני), לוחות MDF ו-OSB, עץ הנדסי, עץ ממוחזר ועוד. ניתן לפנות אלינו לבדיקת זמינות מלאי.',
                },
            },
        },
        {
            category: 'wood',
            question: { localizationObject: { type: 'Literal', text: 'מה ההבדל בין עץ קשה לעץ רך?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'עץ קשה (Hardwood) מגיע מעצי פרי ועלים רחבים — כמו אלון, בוק ואגוז. הוא צפוף, עמיד לשחיקה ומתאים לריצוף, רהיטים ואלמנטים חשופים לבלאי. עץ רך (Softwood) מגיע מעצי מחט — כמו אורן וברוש. הוא קל יותר לעיבוד ומחירו נמוך יותר, ומתאים לבנייה, גינון ומסגרות.',
                },
            },
        },
        {
            category: 'wood',
            question: { localizationObject: { type: 'Literal', text: 'איזה עץ מתאים לשימוש חיצוני?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'לשימוש חיצוני (מרפסות, גדרות, פרגולות) מומלצים: ברוש, ארז, טיק ואיפה-אוויה — עצים בעלי עמידות טבעית גבוהה ללחות ולמזיקים. לחילופין, ניתן להשתמש בעץ מטופל בלחץ (Pressure-Treated) המגיע עם ציפוי הגנה עמיד. נשמח לייעץ בבחירה לפי פרויקט ספציפי.',
                },
            },
        },
        {
            category: 'wood',
            question: { localizationObject: { type: 'Literal', text: 'האם אתם מוכרים עץ ממוחזר?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'כן. עץ ממוחזר (Reclaimed Wood) הוא פתרון אסתטי וידידותי לסביבה. הוא נושא אופי ייחודי, פגמים טבעיים ופטינה שמקנים לפרויקט מראה וינטאג\' ואותנטי. הזמינות תלויה במלאי — יש לפנות לבדיקה.',
                },
            },
        },

        // ─── הזמנה ומשלוח ────────────────────────────────────────────────────
        {
            category: 'orders',
            question: { localizationObject: { type: 'Literal', text: 'מה כמות ההזמנה המינימלית?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'אין כמות הזמנה מינימלית קשיחה. עבור לקוחות פרטיים ניתן להזמין כמות קטנה של מספר לוחות. עבור הזמנות עסקיות גדולות מציעים אנו הנחות כמות וייעוץ לוגיסטי. המחיר לשטרות קטנים עלול לכלול עלות משלוח גבוהה יחסית.',
                },
            },
        },
        {
            category: 'orders',
            question: { localizationObject: { type: 'Literal', text: 'כמה זמן לוקח להכין ולשלוח את ההזמנה?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'הזמנות סטנדרטיות ממלאי מוכן: 1–3 ימי עסקים. הזמנות הדורשות חיתוך, עיבוד או ייבוש מיוחד: 5–10 ימי עסקים. הזמנות ייעודיות מחו"ל: 3–6 שבועות. לאחר הוצאת ההזמנה תישלח הודעת SMS/מייל עם פרטי המשלוח.',
                },
            },
        },
        {
            category: 'orders',
            question: { localizationObject: { type: 'Literal', text: 'האם אתם מספקים לכל הארץ?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'כן, אנו מספקים לכל אזורי הארץ — צפון, מרכז, דרום וירושלים. עלות המשלוח מחושבת לפי נפח ומשקל ההזמנה ואזור היעד. לאזורים מרוחקים ייתכן זמן אספקה ארוך יותר.',
                },
            },
        },
        {
            category: 'orders',
            question: { localizationObject: { type: 'Literal', text: 'האם ניתן לאסוף את ההזמנה עצמאית?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'בהחלט. ניתן לאסוף הזמנות ישירות מהמחסן שלנו — ללא עלות משלוח. יש לתאם מראש זמן איסוף כדי להבטיח שההזמנה מוכנה. בעת האיסוף יש להגיע עם רכב מתאים לפי ממדי הסחורה.',
                },
            },
        },
        {
            category: 'orders',
            question: { localizationObject: { type: 'Literal', text: 'האם ניתן להחזיר או לבטל הזמנה?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'ביטול לפני הכנת ההזמנה: ניתן במלואו ללא עלות. ביטול לאחר הכנה: יגבו דמי ביטול בשיעור 15% מסך ההזמנה. החזרת סחורה שכבר נמסרה תיתכן רק עבור עץ שלא נגע, שלא עבר עיבוד, ובתוך 7 ימים ממועד המסירה. עץ שנחתך לפי הזמנה אינו ניתן להחזרה.',
                },
            },
        },

        // ─── טיפול ועיבוד ────────────────────────────────────────────────────
        {
            category: 'treatment',
            question: { localizationObject: { type: 'Literal', text: 'מה זה עץ מיובש בתנור (Kiln Dried) ולמה זה חשוב?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'יבוש בתנור (Kiln Drying) הוא תהליך בו העץ מיובש בתאי חום מבוקר עד לאחוז לחות נמוך (בד"כ 6–12%). עץ שאינו מיובש כראוי עלול להתכווץ, להתעוות ולהתפצל לאחר ההרכבה. לכל שימוש פנימי — ריצוף, ארונות, חיפויים — מומלץ עץ מיובש בתנור בלבד.',
                },
            },
        },
        {
            category: 'treatment',
            question: { localizationObject: { type: 'Literal', text: 'האם אתם מציעים שירותי חיתוך ועיבוד?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'כן. אנו מציעים חיתוך לאורך, חיתוך לרוחב, כיול (Planing), חריטה ולטיש לפי המידות הנדרשות. עיבוד מותאם מוסיף לזמן ההכנה, אך חוסך עבודה יקרה באתר. ניתן לצרף שרטוט או ממדים בעת הגשת ההזמנה.',
                },
            },
        },
        {
            category: 'treatment',
            question: { localizationObject: { type: 'Literal', text: 'איך לשמור ולתחזק עץ חיצוני?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'עץ חיצוני דורש שכבת הגנה מפני UV, גשם ועובש. מומלץ: (1) לטפל בשמן עץ או לק UV לפחות פעם בשנה; (2) לאפשר לעץ "לנשום" — לא להדביק פלסטיק צמוד; (3) לוודא ניקוז מים מהמשטח; (4) לנקות עלים ולחות שמצטברים. עץ שלא טופל יאפיר ויתבקע תוך שנים ספורות.',
                },
            },
        },
        {
            category: 'treatment',
            question: { localizationObject: { type: 'Literal', text: 'מה ההבדל בין שמן לק וצבע לעץ?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'שמן עץ חודר לתוך הסיב ומזין אותו מבפנים — שומר על מראה טבעי אך דורש ריענון תכוף. לק (Varnish) יוצר שכבת מגן קשה על פני השטח — עמיד יותר אך עלול להתקלף לאורך זמן. צבע מכסה לחלוטין את הצבע הטבעי ומספק הגנה מקסימלית — מומלץ לשימושים תעשייתיים או כשרוצים גוון ספציפי.',
                },
            },
        },

        // ─── מחירים ותשלום ──────────────────────────────────────────────────
        {
            category: 'pricing',
            question: { localizationObject: { type: 'Literal', text: 'כיצד נקבע מחיר העץ?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'מחיר העץ נקבע לפי סוג העץ, עובי, רוחב ואורך (מ"ק — מטר קובי), איכות ודרגה (Grade A/B/C), רמת העיבוד (גולמי, מכויל, מלוטש) ומצב הייבוש. לאחר מילוי טופס הבקשה נשלח אליכם הצעת מחיר מפורטת תוך 24 שעות.',
                },
            },
        },
        {
            category: 'pricing',
            question: { localizationObject: { type: 'Literal', text: 'האם יש הנחות לרכישות בכמות גדולה?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'כן. הזמנות מעל 5 מ"ק זכאיות להנחת כמות. ללקוחות עסקיים קבועים (קבלנים, נגרים) מציעים אנו חשבון לקוח עם מחירון מיוחד, ביצוע הזמנות חוזרות ותשלום על חשבון פתוח. פנו אלינו לפרטים.',
                },
            },
        },
        {
            category: 'pricing',
            question: { localizationObject: { type: 'Literal', text: 'אילו אמצעי תשלום מקובלים?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'אנו מקבלים: כרטיס אשראי (ויזה, מאסטרקארד, אמריקן אקספרס), העברה בנקאית, צ\'קים (לעסקאות גדולות), ומזומן בעת איסוף עצמי. עסקאות מעל 10,000 ₪ מחייבות העברה בנקאית או אשראי בלבד.',
                },
            },
        },
        {
            category: 'pricing',
            question: { localizationObject: { type: 'Literal', text: 'האם ניתן לקבל הצעת מחיר ללא התחייבות?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'בהחלט. מלאו את טופס "בקש הצעת מחיר" באתר עם פרטי הפרויקט והכמויות. הצעת המחיר שלנו מפורטת, ללא עמלה, ותקפה ל-14 ימים. המחויבות מתחילה רק עם אישור ההזמנה בכתב.',
                },
            },
        },

        // ─── תקנים והסמכות ──────────────────────────────────────────────────
        {
            category: 'cert',
            question: { localizationObject: { type: 'Literal', text: 'האם העץ שלכם מוסמך FSC?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'חלק מהמוצרים שלנו נושאים הסמכת FSC (Forest Stewardship Council) — המבטיחה שהעץ הגיע מיערות המנוהלים בצורה אחראית. לקוחות המחייבים FSC (פרויקטים ירוקים, מכרזים ממשלתיים) מוזמנים לציין זאת בעת ההזמנה ונדאג לספק תעודה מתאימה.',
                },
            },
        },
        {
            category: 'cert',
            question: { localizationObject: { type: 'Literal', text: 'האם העץ עומד בתקני בנייה ישראלים?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'כן. עצי המבנה שלנו (קורות, סיפון) עומדים בתקן ישראלי ת"י 1099 ובסיווגי חוזק CE לאירופה. לפרויקטים הדורשים אישורי מהנדס, נוכל לספק גיליון מפרט טכני (Datasheet) מלא עם ערכי אלסטיות וחוזק כפיפה לכל סוג עץ.',
                },
            },
        },
        {
            category: 'cert',
            question: { localizationObject: { type: 'Literal', text: 'כיצד אדע שהעץ שקיבלתי הוא באיכות שהוזמנה?' } },
            answer: {
                localizationObject: {
                    type: 'Literal',
                    text: 'כל משלוח מגיע עם תעודת משלוח הכוללת: סוג העץ, דרגת איכות, מידות, אחוז לחות ומשקל. בעת קבלת הסחורה מומלץ לבדוק שהמידות והכמויות תואמות. במקרה של אי-התאמה יש לדווח תוך 48 שעות ונטפל בהחלפה מיידית.',
                },
            },
        },
    ],
    limitAll: 6,
};

const CommonFAQ: React.FC = () => <ModernFAQ spec={spec} />;

export default CommonFAQ;
